import { TabView, TabPanel } from 'primereact/tabview';
import { ToastService, useDataTableBasic } from '@iamsoftware/react-hooks';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import { AgreementTemplateService as Service } from './AgreementTemplateService';
import { Oauth2GoogleService } from '../../hop-dong/mau-hop-dong/Oauth2GoogleService';
import React, { Fragment, useEffect, useState, useRef } from 'react';

export const TemplateDetail = ({ display, setDisplay }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [templateData, setTemplateData] = useState(null)
  const [items, setItems] = useState([]);
  const [formFieldTypes, setFormFieldTypes] = useState([]);
  const [orderItemFields, setOrderItemFields] = useState([]);
  const [fileBlobUrl, setFileBlobUrl] = useState<string | null>(null);
  const [fileLoading, setFileLoading] = useState(false);
  const fileBlobUrlRef = useRef<string | null>(null);
  useEffect(() => {
    if (display?.agreementId) {
      Service.get(display.agreementId).then(data => {
        if (data.productCategoryId) {
          data.categories = { value: data.productCategoryId, label: `[${data.categoryPseudoId}] - ${data.categoryName}` }
        }
        setItems(data.dbFormFields.map(field => {
          field.isRequired = field.isRequired === 'Y';
          return field
        })
        )
        setTemplateData(data)
      });
      Service.getFormFieldTypes().then(data => {
        setFormFieldTypes(data.listData.map(item => {
          return { value: item.enumId, label: item.description };
        }));
      });
      Service.getOrderItemPrototypeFields().then(data => {
        setOrderItemFields(data.items.map(item => {
          return { value: item.fieldName, label: item.title };
        }));
      });

    } else {
      setTemplateData(null)
      setFileBlobUrl(null)
      setFileLoading(false)
    }
  }, [display])

  useEffect(() => {
    const fileId = templateData?.fileId;
    if (display && fileId && !fileBlobUrlRef.current) {
      setFileLoading(true);
      // Download file dưới dạng blob
      Oauth2GoogleService.getPdf(fileId)
        .then((blob) => {
          // Tạo blob URL
          const blobUrl = URL.createObjectURL(blob);

          // Thu hồi URL cũ nếu có
          if (fileBlobUrlRef.current) {
            URL.revokeObjectURL(fileBlobUrlRef.current);
          }

          fileBlobUrlRef.current = blobUrl;
          setFileBlobUrl(blobUrl);
          setFileLoading(false);
        })
        .catch((err) => {
          console.error('Error loading file:', err);
          ToastService.error('Không thể tải file');
          setFileLoading(false);
        });
    } else if (!display) {
      // Reset state khi đóng dialog
      if (fileBlobUrlRef.current) {
        URL.revokeObjectURL(fileBlobUrlRef.current);
        fileBlobUrlRef.current = null;
      }
      setFileBlobUrl(null);
      setFileLoading(false);
    }
  }, [display, templateData?.fileId])

  // Cleanup khi component unmount
  useEffect(() => {
    return () => {
      if (fileBlobUrlRef.current) {
        URL.revokeObjectURL(fileBlobUrlRef.current);
        fileBlobUrlRef.current = null;
      }
    };
  }, [])
  const downloadTemplate = (type: string) => () => {
    window.open(`${Service.baseURL}/${Service.entity}/${display?.agreementId}/download-${type}`);
  }
  const footer = (<Fragment>
    {activeIndex === 1 && <Button label="Lưu" icon="pi pi-check" className="p-button-sm" type="button" onClick={() => setSubmitting(true)} loading={submitting} />
    }
  </Fragment>)
  return (
    <Dialog header={'Chi tiết mẫu hợp đồng'} maximized={true} draggable={false} footer={footer} visible={!!display} style={{ width: '100%' }} position="top" onHide={() => {
      setDisplay(false);
    }}>
      <TabView activeIndex={activeIndex} style={{ height: '100%' }} onTabChange={(e) => setActiveIndex(e.index)}>
        <TabPanel header="Mẫu hợp đồng">
          {(() => {
            const fileId = templateData?.fileId;

            if (fileId && fileBlobUrl) {
              // Hiển thị file từ blob URL
              return (
                <iframe
                  className={'file-tab-panel'}
                  src={fileBlobUrl}
                  title="Mẫu hợp đồng"
                  style={{ width: '100%', height: 'calc(100vh - 185px)', border: 'none' }}
                />
              );
            }

            if (fileId && fileLoading) {
              return (
                <div style={{ padding: '2rem', textAlign: 'center' }}>
                  <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem', marginBottom: '1rem' }}></i>
                  <p>Đang tải file...</p>
                </div>
              );
            }

            if (display?.agreementId) {
              return <p className="text-sm text-600 m-0">Đang tải file...</p>;
            }

            return <p className="text-sm text-600 m-0">Không có file để hiển thị.</p>;
          })()}
        </TabPanel>
        <TabPanel header="Trường thông tin">
          <FormFields setDisplay={setDisplay} formFieldTypes={formFieldTypes} orderItemFields={orderItemFields} setItems={setItems} items={items} agreementId={templateData?.agreementId} submitting={submitting} setSubmitting={setSubmitting} />
        </TabPanel>
      </TabView>
    </Dialog>
  )
}

const FormFields = ({ agreementId, submitting, setSubmitting, setDisplay, items, setItems, formFieldTypes, orderItemFields }) => {



  const dataKey = 'fieldName';

  const onEditorChange = (rowData, column, newValue) => {
    setItems(prevItems => prevItems.map(prevItem => {
      if (prevItem[dataKey] === rowData[dataKey]) {
        return {
          ...prevItem,
          [column.field]: newValue
        }
      }
      return prevItem;
    }));
  }

  const { render: renderDataTableItem } = useDataTableBasic({
    tableHeader: `Danh sách trường thông tin`,
    dataKey,
    indexColumnWidth: 45,
    columns: [
      {
        field: 'title', header: 'Tên trường', width: 250,
      },
      {
        field: 'tooltip', header: 'Mô tả', minWidth: 200,
        dataType: 'editor', editorConfig: {
          onEditorChange,
        }
      },
      {
        field: 'isRequired', header: 'Bắt buộc', width: 100,
        dataType: 'editor', editorConfig: {
          onEditorChange,
          field: { type: 'Checkbox' }
        }, className: 'text-center'
      },
      {
        field: 'fieldTypeEnumId', header: 'Kiểu dữ liệu', width: 250,
        dataType: 'editor', editorConfig: {
          onEditorChange,
          field: { type: 'Dropdown', DropdownProps: { options: formFieldTypes, showClear: true, style: { width: '100%' } } }
        }
      }
    ],
    items
  });

  useEffect(() => {
    if (submitting) {
      const result = items.map(item => {
        item.isRequired = item.isRequired ? 'Y' : 'N';
        return item;
      })
      Service.setFormFields(agreementId, result).then(() => {
        ToastService.success();
        setDisplay(null)
      }).catch(() => {
      }).finally(() => {
        setSubmitting(false);
      });
    }
  }, [submitting]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="grid">
      <div className="col-12">
        {renderDataTableItem()}
      </div>
    </div>
  );

}